module.exports = __webpack_public_path__ + "img/top-bar.ebd67ef7.png";